import { safeValue } from "@common/src/utils/common";
const app = {
  namespaced: true,
  state: {
    unreadNoticeCount: 0
  },
  mutations: {
    setUnreadNoticeCount(state, data) {
      state.unreadNoticeCount = data;
    }
  },
  actions: {
    async getHomeOrderData({ rootState }, params = {}) {
      const data = await rootState.http("/home/getHomeOrderInfo", params);
      return data;
    },
    async getHomeCustomerData({ rootState }, params = {}) {
      const data = await rootState.http("/home/getHomeCustomerInfo", params);
      return data;
    },
    async getOrderStatistic({ rootState }, params = {}) {
      const data = await rootState.http("/order/orderStatistic", params);
      return data;
    },
    async getNoticeList({ rootState }, params = {}) {
      const data = await rootState.http("/inboxMessage/queryInboxMessage", params);
      return data;
    },
    async readNotice({ rootState, dispatch }, params = {}) {
      const data = await rootState.http("/inboxMessage/readInboxMessage", params);
      dispatch("getUnreadNoticeCount");
      return data;
    },
    async getUnreadNoticeCount({ rootState, commit }, params = {}) {
      const data = await rootState.http("/inboxMessage/getInboxMessageUnReadCount", params);
      commit("setUnreadNoticeCount", safeValue(data, "data.unReadCount", 0));
      return data;
    },
    async getAnnouncementList({ rootState }, params = {}) {
      const data = await rootState.http("/announcement/store/queryEnableAnnouncement", params);
      return data;
    }
  }
};

export default app;
